

export const setCreditManagementInputData = (data) => ({
    type: 'SET_CREDIT_MANAGEMENT_INPUT_DATA',
    payload: data
});

export const setCreditManagementDropDownData = (data) => ({
    type: 'SET_CREDIT_MANAGEMENT_DROP_DOWN_DATA',
    payload: data
});

export const setCreditManagementTableData = (data) => ({
    type: 'SET_CREDIT_MANAGEMENT_TABLE_DATA',
    payload: data
});

export const setCreditManagementUsageTableData = (data) => ({
    type: 'SET_CREDIT_MANAGEMENT_USAGE_TABLE_DATA',
    payload: data
});

export const setCreditManagementMeterTableData = (data) => ({
    type: 'SET_CREDIT_MANAGEMENT_METER_TABLE_DATA',
    payload: data
});

export const setCreditManagementAdjEntryTableData = (data) => ({
    type: 'SET_CREDIT_MANAGEMENT_ADJ_ENTRY_TABLE_DATA',
    payload: data
});

export const isCreditManagementDataLoading = (data) => ({
    type: 'IS_CREDIT_MANAGEMENT_DATA_LOADING',
    payload: data
});




